import { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { getCompanyAddress } from '@helpers/companies';
import { SystemFieldType } from '@constants/surveys';

const Negative = ({ locationSurveyId, location }) => {
    const iframeRef = useRef(null);
    const { watch, control } = useFormContext();
    const customFields = useWatch({ control, name: 'customFields' });
    const emailField = watch('contactEmail');
    const emailFieldRequired = watch('contactEmailRequired');
    const phoneField = watch('contactPhone');
    const phoneFieldRequired = watch('contactPhoneRequired');
    const nameField = watch('contactName');
    const nameFieldRequired = watch('contactNameRequired');

    useEffect(() => {
        const controller = new AbortController();
        const data = {
            locationName: location.locationName,
            businessAddress: getCompanyAddress(location.addressLine1, location.city),
            hasBusinessAddress: location.hasBusinessAddress,
            customFields,
            systemFields: {
                Email: {
                    type: SystemFieldType.EMAIL,
                    required: emailFieldRequired,
                    enable: emailField,
                },
                Phone: {
                    type: SystemFieldType.PHONE,
                    required: phoneFieldRequired,
                    enable: phoneField,
                },
                Name: {
                    type: SystemFieldType.NAME,
                    required: nameFieldRequired,
                    enable: nameField,
                },
            },
        };
        iframeRef.current?.contentWindow?.postMessage({ type: 'pl-preview-survey-negative', data }, '*');
        const sendUpdatedData = event => {
            if (event.origin === process.env.REACT_APP_SURVEY_DOMAIN) {
                const message = event.data;
                if (message.type === 'pl-preview-iframe-loaded') {
                    iframeRef.current?.contentWindow?.postMessage({ type: 'pl-preview-survey-negative', data }, '*');
                }
            }
        };
        window.addEventListener('message', sendUpdatedData, { signal: controller.signal });
        return () => controller.abort();
    }, [
        location,
        customFields,
        emailField,
        emailFieldRequired,
        phoneField,
        phoneFieldRequired,
        nameField,
        nameFieldRequired,
    ]);

    return (
        <iframe
            ref={iframeRef}
            allow="autoplay"
            width="100%"
            height="100%"
            src={`${process.env.REACT_APP_SURVEY_DOMAIN}/preview/negative/${locationSurveyId}`}
            frameBorder="0"
        ></iframe>
    );
};

export default Negative;
